import { render, staticRenderFns } from "./formDelivery.vue?vue&type=template&id=d46a7746&scoped=true"
import script from "./formDelivery.vue?vue&type=script&lang=js"
export * from "./formDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46a7746",
  null
  
)

export default component.exports